window.responsiveVideoIsVisible = false
window.responsiveVideoDefaultFilename = ""

class ResponsiveVideo extends HTMLElement {
  connectedCallback() {
    if (window.responsiveVideoIsVisible) {
      this.innerHTML = this.getVideoMarkup()
    } else {
      window.responsiveVideoDefaultFilename = this.getFilename()
    }

    window.addEventListener("resize", () => {
      this.processMarkup()
    })
    window.addEventListener("scroll", () => {
      this.processMarkup()
    })

    const options = {
      root: document,
      rootMargin: "0px",
      threshold: 0,
    }
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.responsiveVideoIsVisible = true
        }
      })
    }
    const observer = new IntersectionObserver(callback, options)
    const target = document.querySelector("#ultima-pullout-video")
    observer.observe(target)
  }
  disconnectedCallback() {
    window.removeEventListener("resize", () => false)
    window.removeEventListener("scroll", () => false)
  }
  processMarkup() {
    const videoFile = this.querySelector("video")
    const currentFile = videoFile
      ? videoFile.dataset.filename
      : window.responsiveVideoDefaultFilename
    const newFile = this.getFilename()
    if (currentFile != newFile.mp4 && window.responsiveVideoIsVisible) {
      this.innerHTML = this.getVideoMarkup()
    }
  }
  getFilename() {
    const width = window.innerWidth
    const files = window.responsiveVideos
    let fileToUse = null
    if (width > 1279) {
      fileToUse = files[2]
    } else if (width > 767) {
      fileToUse = files[1]
    } else {
      fileToUse = files[0]
    }
    return fileToUse
  }
  getVideoMarkup() {
    const fileName = this.getFilename()
    return `
        <video data-filename="${fileName.mp4}" autoplay playsinline muted loop>
          <source src="${fileName.webm}" type="video/webm" />
          <source src="${fileName.mp4}" type="video/mp4" />
        </video>
      `
  }
}
customElements.define("responsive-video", ResponsiveVideo)
